export const BASE_PROFILE_PATHNAME = '/profile';
export const EDIT_PROFILE_PATHNAME = `${BASE_PROFILE_PATHNAME}/edit`;
export const PROFILE_SUBROUTES = Object.freeze({
  OVERVIEW: BASE_PROFILE_PATHNAME,
  CITY: `${EDIT_PROFILE_PATHNAME}/city`,
  SPECIAL_DATES: `${EDIT_PROFILE_PATHNAME}/special-dates`,
  PAYMENT_METHODS: `${EDIT_PROFILE_PATHNAME}/payment-methods`,
  DIET_PREFERENCES: `${EDIT_PROFILE_PATHNAME}/diet-preferences`,
});
